// Copy for the Action Center nav popover (shown on non-home pages).
export const POPOVER_CAPTION = "ACTION CENTRE - REVIEW REQUIRED";
export const POPOVER_REVENUE_TITLE = "Increase revenue up to";
// Deliberately different copy from the banner's unlock message.
export const POPOVER_UNLOCK_TITLE = "New buyer invitations waiting";
export const POPOVER_DESCRIPTION =
  "Don't miss out on revenue - review your growth opportunities to improve performance and maximise bookings.";
export const POPOVER_CTA_LABEL = "Review Actions";
export const POPOVER_HEAP_ID_PREFIX = "action-center-popover";
export const POPOVER_TARGET_SELECTOR = '.sidenav__menu a[href="/"]';
// Routes that count as "home" — the popover only shows on other pages.
export const HOME_ROUTES = ["/", "/performance"];
